import { combineReducers } from "redux";
import initReducer from "./init";
import calcReducer from "./calc";
//console.log("src/reducers/reducer.js");

// reducer

const rootReducer = combineReducers({
  init: initReducer,
  calc: calcReducer,
});

export default rootReducer;
